import React, { useEffect, useRef, useState } from 'react';

import FlagIcon from 'assets/myLeads/flag.svg';
import { PRIORITY_OPTION } from 'constants/constants';

import {
  Dropdown,
  DropdownButton,
  DropdownIcon,
  DropdownItem,
  DropdownMenu,
  FlagImg,
} from './PriorityDropdown.styles';

const PriorityDropdown = ({
  currentPriority,
  onPriorityChange,
  onClick,
  canEditPriority = true,
  onOpenChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);

  const currentOption =
    PRIORITY_OPTION.find((opt) => opt.id === currentPriority?.toLowerCase()) ||
    PRIORITY_OPTION[4];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleToggle = (e) => {
    e.stopPropagation();
    if (!canEditPriority) return;
    if (onClick) onClick(e);

    const newIsOpen = !isOpen;

    // Calculate if dropdown should open upward
    if (newIsOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - rect.bottom;
      const dropdownHeight = 200; // Approximate height of dropdown menu

      setOpenUpward(spaceBelow < dropdownHeight && rect.top > dropdownHeight);
    }

    setIsOpen(newIsOpen);
    if (onOpenChange) onOpenChange(newIsOpen);
  };

  const handleSelect = (priorityId, e) => {
    e.stopPropagation();
    onPriorityChange(priorityId);
    setIsOpen(false);
  };

  return (
    <Dropdown ref={dropdownRef} $isOpen={isOpen}>
      <DropdownButton
        onClick={handleToggle}
        $theme={currentOption}
        style={!canEditPriority ? { cursor: 'default' } : undefined}
      >
        <FlagImg $src={FlagIcon} $theme={currentOption} />
        {currentOption?.label}
        {canEditPriority && <DropdownIcon $isOpen={isOpen}>▼</DropdownIcon>}
      </DropdownButton>
      {isOpen && canEditPriority && (
        <DropdownMenu $openUpward={openUpward}>
          {PRIORITY_OPTION.map((option) => (
            <DropdownItem
              key={option.id}
              onClick={(e) => handleSelect(option.id, e)}
              $theme={option}
              $isActive={option.id === currentPriority?.toLowerCase()}
            >
              {option.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      )}
    </Dropdown>
  );
};

export default PriorityDropdown;
